<template>
    <div class="customer_home system_container">
        <div class="main_table">
        <md-button class="md-raised md-primary btn_customer" @click="showAddSystemForm"> <md-icon class="md-size-2x">add</md-icon>Add System</md-button>
            <md-table v-model="systems" md-card style="max-height:540px">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell  md-label="System Name">{{ item.name }}</md-table-cell>
                <md-table-cell md-label="Description"  >{{ item.description }}</md-table-cell>
                <md-table-cell md-label="Status"  ><div :style="{color:item.active?'green':'red'}">{{item.active ? 'Active' : 'Inactive'}}</div></md-table-cell>
                <md-table-cell md-label="" >
                    <md-menu md-size="medium" md-align-trigger>
                    <md-button md-menu-trigger><md-icon>more_horiz</md-icon></md-button>
                    <md-menu-content>
                        <md-menu-item @click="showUpdate(item)">Update</md-menu-item>
                        <md-menu-item @click="showDelete(item)"><div style="color:red">Delete</div></md-menu-item>
                    </md-menu-content>
                    </md-menu>
                </md-table-cell>
                </md-table-row>
            </md-table>
        </div>
      
    <md-dialog :md-active.sync="delete_active" class="custom_dialog_container">
        <md-dialog-title >
          <label class='lb_close' @click="delete_active=false"><md-icon class="icon_close">clear</md-icon></label>
          <label class='lb-title'>Delete System</label>
        </md-dialog-title>
        <md-dialog-content >
          <span>Do you want to delete this system?</span>
          <br>
          <span>All related data will alse be deleted.</span>
        </md-dialog-content>
        <md-dialog-actions >
          <md-button class="md-raised" @click="delete_active = false">Cancel</md-button>
          <md-button class="md-raised md-accent" @click="handleDeleteSystem">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="update_active" class=" custom_dialog_container ">
      <md-dialog-title >
        <label class='lb_close' @click="update_active=false"><md-icon class="icon_close ">clear</md-icon></label>
        <label class='lb-title'>Update System</label>
      </md-dialog-title>
      <md-dialog-content>
      <form ref="updateSystemForm">
        <div class="custom_input" style="margin-top:0px">
          <input type="text" v-model="tempSystem.name" required>
          <label >System Name*</label>
        </div>
        <div style="margin-top:20px">
            <label>Status</label>
            <div class="margin-top:20px">
              <md-radio v-model="tempSystem.active" class="md-primary" :value="true">Active</md-radio>
              <md-radio v-model="tempSystem.active" class="md-primary" :value="false">Inactive</md-radio>
            </div>
        </div>
        <div class="custom_input">
          <input type="text"  v-model="tempSystem.description">
          <label class="label">Description</label>
        </div>
      </form>
      </md-dialog-content>
      <md-dialog-actions>
         <md-button class="md-raised" @click="update_active = false">Cancel</md-button>
         <md-button class="md-raised md-primary" @click="handleUpdateSystem">Update</md-button>
      </md-dialog-actions>
    </md-dialog>
    
    <md-dialog :md-active.sync="add_active" class="custom_dialog_container">
      <md-dialog-title >
        <label class='lb_close'  @click="add_active=false"><md-icon class="icon_close ">clear</md-icon></label>
        <label class='lb-title'>Add System</label>
      </md-dialog-title>
      <md-dialog-content>
      <form  ref="addSystemForm">
        <div class="custom_input" style="margin-top:0px">
          <input type="text" v-model="tempSystem.name" required>
          <label>System Name*</label>
        </div>
        <div style="margin-top:20px">
            <label>Status</label>
            <div class="margin-top:20px">
              <md-radio v-model="tempSystem.active" class="md-primary" :value="true">Active</md-radio>
              <md-radio v-model="tempSystem.active" class="md-primary" :value="false">Inactive</md-radio>
            </div>
        </div>
        <div class="custom_input">
          <input type="text"  v-model="tempSystem.description">
          <label class="label">Description</label>
        </div>
      </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-raised" @click="add_active = false">Cancel</md-button>
        <md-button class="md-raised md-primary" @click="handleAddSystem">Add</md-button>
      </md-dialog-actions>
    </md-dialog>
</div>
</template>
<script>
import request from '@/utils/request'

export default {
  name:'CustomerSystem',
  created() {
    request('get', '/systems')
      .then(data => {
        this.systems = data.systems
      })
      .catch(err => console.log(err))
  },
  data(){
    return{
      update_active:false,
      delete_active:false,
      add_active:false,
      radio:'',
      systems: [],
      tempSystem: {}
    }
  },
  methods:{
    showAddSystemForm() {
      this.tempSystem = {
        name: '',
        description: '',
        active: true
      }
      this.add_active=true
    },
    showUpdate(el){
      this.tempSystem={
        ...el
      }
      this.update_active=true
    },
    showDelete(el){ 
      this.tempSystem={
        ...el
      }
      this.delete_active=true;
    },
    handleAddSystem() {
      if (this.$refs.addSystemForm.reportValidity()) {
        request('post', '/systems', this.tempSystem)
          .then(data => {
            this.systems.push(data.system)
            this.add_active = false
          })
          .catch(err => {
            console.log(err)
            alert(err.message)
          })
      }
    },
    handleUpdateSystem() {
      if (this.$refs.updateSystemForm.reportValidity()) {
        request('put', '/systems', this.tempSystem)
          .then(data => {
            for (let i = 0; i < this.systems.length; i++) {
              if (this.systems[i]._id == data.system._id) {
                this.systems[i] = data.system
                break
              }
            }
            this.update_active = false
          })
          .catch(err => {
            alert(err.message)
          })
      }
    },
    handleDeleteSystem() {
      request('delete', `/systems/${this.tempSystem._id}`)
        .then(() => {
          for (let i = 0; i < this.systems.length; i++) {
            if (this.systems[i]._id == this.tempSystem._id) {
              this.systems.splice(i, 1)
              break
            }
          }
          this.delete_active=false;
        })
        .catch(err => {
          alert(err.message)
        })
    }
  },
  watch:{
    site_selected:function(){
      if(this.site_selected.length>0)
      {
        this.num_sites_selected=this.site_selected.length+" Sites/Projects";
      }
      else
      {
        this.num_sites_selected='';
      }
    }
  }
}
</script>